import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { TerminalTransactionApiModel } from 'app/models/terminal-transaction-api.model';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwPayloadModel } from 'app/models/payload.model';

@Injectable()
export class MwTerminalTransactionsApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private apiEndpoint =
    '/transport/v1/Companies/{companyId}/TerminalTransactions';

  getById(id: number): Promise<TerminalTransactionApiModel> {
    const options = new MwLoadOptions({
      numericParameters: { terminalTransactionId: true },
      filter: ['terminalTransactionId', '=', id],
    });
    const params = `?${this.loadOptionsService.buildQuery(options)}`;

    return this.http
      .authGet<TerminalTransactionApiModel>(`${this.apiEndpoint}${params}`)
      .toPromise();
  }

  gerTerminalTransactions(
    loadOptions?: MwLoadOptions
  ): Observable<MwPayloadModel<TerminalTransactionApiModel[]>> {
    let params = loadOptions
      ? this.loadOptionsService.buildQuery(loadOptions)
      : '';

    if (params) {
      params = '?' + params;
    }

    return this.http.authGet<MwPayloadModel<TerminalTransactionApiModel[]>>(
      `${this.apiEndpoint}${params}`
    );
  }

  updateTerminalTransaction(
    terminalTransaction: TerminalTransactionApiModel
  ): Observable<any> {
    return this.http.authPut<TerminalTransactionApiModel>(this.apiEndpoint, {
      body: terminalTransaction,
    });
  }
}
